import React, { Component } from 'react'
let count = 0
export default class Http extends Component {
    render() {
		return null
	}
	shouldComponentUpdate() {
		return false
	}
    componentWillMount () {
    	//console.warn('Http componentWillMount', this.props.id)
        this.doRequest(this.props)
    }
	componentWillReceiveProps(props) {
		if (JSON.stringify(props) === JSON.stringify(this.props)) return
		//console.warn('Http componentWillReceiveProps')
		this.doRequest(props)
	}
	componentWillUnmount () {
		//console.warn('Http componentWillUnMount', this.props.id)
	}

    doRequest(props) {
        //console.log('Http request', props)
        let { method, url, headers, data, onBefore, onSuccess, onError, post } = props
	    if(onBefore)
		    onBefore()
		let request = new XMLHttpRequest()

		if (this.xhrRequest) {
			this.xhrRequest.abort()
		}
		if(!post) return
		this.xhrRequest = request
		if(method == 'GET' && typeof data == 'string'){
			data = JSON.parse(data)
			url = url + "?" + Object.keys(data).map((key) => `${key}=${data[key]}` ).join("&")
		}
		console.log(url)
		request.open(method || 'GET', url, true)
		Object.keys(headers || {}).forEach(key => request.setRequestHeader(key, headers[key]))
		request.send(data)
		if (!post) count++

		request.onload = function() {
			if (!post) count--
        	//console.log('Http response', request)
		  	if (request.status >= 200 && request.status < 400) {
		    	if (onSuccess) onSuccess(request.responseText)
		  	} else {
		    	// We reached our target server, but it returned an error
		    	if (onError) onError(request)
		  	}
		}

		request.onerror = function(e) {
			// There was a connection error of some sort
			if (!post) count--
	    	if (onError) onError(e)
		}
    }
}

export function getPendingRequestCount(){ return count }



// WEBPACK FOOTER //
// ./src/components/drivers/Http.js